<template>
  <el-dialog
    :title="dialogTitle"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="80%"
    @close="closeDialog"
  >
    <div>
      <SiruiSearch
        ref="generalServiceRef"
        :query="generalServiceForm"
        labelWidth="120px"
        :columns="formColumn"
        :isQueryPanel="false"
        :rules="formRules"
        :colStyle="{ marginBottom: '10px' }"
      ></SiruiSearch>
    </div>
    <div class="order-track" v-if="isDetail">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="orderTrackings"
        :paging="false"
        :reserve="false"
        :setting="false"
        :columns="yunDanColumn"
        :maxHeight="200"
      >
        <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in yunDanColumn"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'operate'">
              <el-button size="mini" type="text" @click="handelClick('0', scope.row)"
                >查看GPS定位</el-button
              >
              <el-button size="mini" type="text" @click="handelClick('1', scope.row)"
                >查看轨迹</el-button
              >
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{
        this.$t('receivablesManageList.button.cancel')
      }}</el-button>
      <el-button v-if="!isDetail" type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import {
    baseColumnList,
    baseFormRules,
    truckColumnList,
    truckFormRules,
    trackColumns,
    generalColumns,
  } from '../data';
  import { mapState } from 'vuex';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import API from '@/api/intermodality/order';
  import XEUtils from 'xe-utils';
  // import bus from '@/common/js/bus';
  export default {
    name: 'generalServicesDialog',
    mixins: [orderMixin],
    props: [
      'type',
      'dialogVisible',
      'isEdit',
      'isCopy',
      'dialogTitle',
      'editFormVal',
      'turnType',
      'typeList',
      'isDetail',
      'containerTypeList',
      'contractRoutes',
      'contractCode',
    ],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    mounted() {
      this.getParentProductList();
    },
    computed: {
      formColumn() {
        return this.type === 'general' ? baseColumnList(this) : truckColumnList(this);
      },
      formRules() {
        return this.type === 'general' ? baseFormRules : truckFormRules;
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      yunDanColumn() {
        return this.type === 'general' ? generalColumns : trackColumns;
      },
      typeListOne() {
        return this.turnType === '1' ? this.containerTypeList : this.typeList;
      },
    },
    created() {
      console.log(this.containerTypeList, 'this.containerTypeList');
      // this.getRouteNameList();
      this.getUnitList();
      this.getWeightUnitList();
      // 获取商品名称下拉列表
      this.getGoodsList();
      this.getCarList();
      this.getWeightList();
      this.getVolumeUnitList();
      // this.getContainerTypeList();
      this.getServiceProviderList();
      this.getServiceMethodsList();
      if (this.isEdit || this.isDetail || this.isCopy) {
        Object.assign(this.generalServiceForm, this.editFormVal);
      }
      if (this.isDetail) {
        this.getInstructDetail();
      }
    },
    data() {
      return {
        generalServiceForm: {
          serviceProviderCode: '', // 服务提供方编码
          serviceProviderName: '', // 服务提供方
          routeCode: '',
          departurePlaceName: '',
          departurePlaceCode: '',
          destinationName: '',
          destinationCode: '',
          remarks: '',
          contactConsignor: '', //发货人联系
          contactConsignorPhone: '', //发货人联系方式发无字段
          planPickupDate: '', // 计划提货日期无字段
          pickupRequire: '', // 提货要求无字段
          contactConsignee: '', // 收获联系人
          contactConsigneePhone: '', // 收货人联系方式无字段
          planDeliveryDate: '', // 计划送货日期无字段
          deliveryRequire: '', // 送货要求
          customerRequireModel: '', // 客户要求车型无字段
          customerRequireSize: '', // 客户要求吨位尺寸
          customerRequireQty: '', // 车型要求数量
          productParentName: '', // 商品名称
          productParentNo: '', // 商品父类编码
          productDetailCode: '', // 商品子类简码
          detailProductItems: '', // 品目
          detailProductModel: '', // 规格
          qty: '', // 件数
          qtyUnit: '', // 件数单位
          roughWeight: '', // 毛重
          roughWeightUnit: '', // 毛重单位
          netWeight: '', // 净重
          netWeightUnit: '', // 净重单位
          volume: '', // 体积
          planReceiptDate: '', // 计划回单日期
          transportMode: '', //运输服务方式
          putContainerLadeNo: '', //放箱提单号
          planPickupContainerDate: '', // 预提箱日期
          materialNo: '',
          planArrivalDate: '',
          receiveUnit: '',
          goodsDesc: '',
        },
        detailCodeList: [], // 商品子类编码下拉
        orderTrackings: [],
        formItemDisable: false,
        otherFormItem: false,
        trackColumns,
        generalColumns,
      };
    },
    methods: {
      closeDialog() {
        // 关闭
        Object.keys(this.generalServiceForm).forEach((item) => {
          this.generalServiceForm[item] = '';
        });
        this.$emit('close');
      },
      save() {
        this.$refs.generalServiceRef.validate((valid) => {
          if (valid) {
            let saveObj = {};
            saveObj = XEUtils.clone(this.generalServiceForm, true);
            this.$emit('submit', saveObj, this.type, this.isEdit);
            this.closeDialog();
          }
        });
      },
      changeRouteHandler(val) {
        console.log(this.contractRoutes, val, '1111');
        this.contractRoutes.forEach((route) => {
          if (route.code === val) {
            console.log(route, 'route');
            this.generalServiceForm.departurePlaceName = route.departurePlaceDetail;
            this.generalServiceForm.destinationName = route.destinationDetail;
            // this.generalServiceForm.departurePlaceName = route.beginDetailAddress;
            // this.generalServiceForm.destinationName = route.goalDetailAddress;
            // this.generalServiceForm.departurePlaceCode = route.beginAreaNo
            //   ? `${route.beginProvinceNo},${route.beginCityNo},${route.beginAreaNo}`
            //   : `${route.beginProvinceNo},${route.beginCityNo}`;
            // this.generalServiceForm.destinationCode = route.goalAreaNo
            //   ? `${route.goalProvinceNo},${route.goalCityNo},${route.goalAreaNo}`
            //   : `${route.goalProvinceNo},${route.goalCityNo}`;
          }
        });
      },
      changeProductHandler(val) {
        console.log(val, '111111');
        this.generalServiceForm.productParentName = this.productParentList.find(
          (item) => item.value == val
        )?.label;
        this.generalServiceForm.productParentNo = val;
        this.generalServiceForm.productDetailCode = '';
        // 通过名称获取商品子类简码
        this.getParentProductList({
          productChName: this.generalServiceForm.productParentName,
          productParentCode: this.generalServiceForm.productParentNo,
        });
      },
      // 商品编码下拉
      changeSearchCodeHandler(val) {
        this.productChildList.forEach((item) => {
          if (item.productDetailCode === val) {
            this.generalServiceForm.productDetailCode = item.productDetailCode;
            this.generalServiceForm.detailProductItems = item.detailProductItems || '';
            this.generalServiceForm.detailProductModel = item.detailProductModel || '';
            return;
          }
        });
      },
      // 服务供方下拉
      changeServiceProviderHandler(val) {
        this.serviceProviderList.forEach((service) => {
          if (service.supplierCode === val) {
            this.generalServiceForm.serviceProviderName = service.supplierName;
            this.generalServiceForm.serviceProviderCode = service.supplierCode;
            this.generalServiceForm.departurePlaceName = service.departurePlaceName;
            this.generalServiceForm.destinationName = service.destinationName;
          }
        });
      },
      getInstructDetail() {
        const instructId = this.generalServiceForm.id;
        console.log(instructId, 'instructCode');
        const params = {};
        params.id = instructId;
        this.$axios.post(API.INSTRUCT_DETAIL, params).then((res) => {
          console.log(res, '12333');
          if (res.data.code === 0) {
            console.log(res, '111');
            this.orderTrackings = res.data.data.orderTrackings || [];
          }
        });
      },
      handelClick(val, row) {
        console.log(val, row);
      },
    },
  };
</script>
